import React, { ComponentType } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { mindupAdminMobilePaths, pagePaths } from 'constants/path';

const PrivateRoute = ({ component: Component }: { component: ComponentType<any> }) => {
    let token = '';

    const item = localStorage.getItem('loginData');

    if (item) {
        try {
            const storedData = JSON.parse(item);
            token = storedData?.state?.loginData?.token || '';
        } catch (error) {
            console.error('Invalid JSON:', item);
        }
    }

    return token ? <Component /> : <Navigate to={pagePaths.login} replace />;
};

export default PrivateRoute;

export const MindUpAdminPrivateRoute = ({ component: Component }: { component: ComponentType<any> }) => {
    const location = useLocation();
    let token = '';

    const item = localStorage.getItem('loginData');

    if (item) {
        try {
            const storedData = JSON.parse(item);
            token = storedData?.state?.loginData?.token || '';
        } catch (error) {
            console.error('Invalid JSON:', item);
        }
    }

    if (!token) {
        const currentUrl = location.pathname + location.search;
        localStorage.setItem('redirectAfterLogin', currentUrl);

        return <Navigate to={mindupAdminMobilePaths.login} replace />;
    }

    return <Component />;
};
// TODO: token check logic 수정, 테스트는 완료
// const PrivateRoute = ({ component: Component }: { component: ComponentType<any> }) => {
//     let token = '';

//     // const item = localStorage.getItem('loginData');
//     const item = axios.defaults.headers.common['Authorization'] as string;
//     // console.log(axios.defaults.headers.common['Authorization']);
//     if (item) {
//         try {
//             const storedData = item as string;
//             token = storedData;
//         } catch (error) {
//             console.error('Invalid JSON:', item);
//         }
//     }

//     return token ? <Component /> : <Navigate to={pagePaths.login} replace />;
// };

// export default PrivateRoute;
